export default __webpack_public_path__ + "static/media/69.87b9257c.jpg";